const locale = {
  SIGN_IN_TITLE: 'Вход',
  SIGN_IN_SUBTITLE: 'Влезте в профила си',
  EMAIL_LABEL: 'Имейл адрес',
  PASSWORD_LABEL: 'Парола',
  SIGN_IN_BUTTON: 'Вход',
  FORGOT_PASSWORD: 'Забравена парола?',
  NO_ACCOUNT: 'Нямате профил?',
  SIGN_UP_LINK: 'Регистрирайте се тук',
  SIGNING_IN: 'Влизане...',
  
  // Validation messages
  EMAIL_REQUIRED: 'Имейл адресът е задължителен',
  EMAIL_INVALID: 'Моля, въведете валиден имейл адрес',
  PASSWORD_REQUIRED: 'Паролата е задължителна',
  // deepcode ignore NoHardcodedPasswords: just a label
  PASSWORD_MIN_LENGTH: 'Паролата трябва да е поне 8 символа',
  
  // Error messages
  INVALID_CREDENTIALS: 'Невалиден имейл или парола',
  ACCOUNT_NOT_FOUND: 'Профилът не е намерен',
  TOO_MANY_ATTEMPTS: 'Твърде много опити. Моля, опитайте отново по-късно',
  NETWORK_ERROR: 'Грешка в мрежата. Моля, проверете връзката си',
  UNKNOWN_ERROR: 'Възникна грешка. Моля, опитайте отново',
  ACCOUNT_LOCKED: 'Профилът е заключен. Свържете се с администратор',
  EMAIL_NOT_VERIFIED: 'Имейлът не е потвърден. Проверете пощата си',
  
  // PropelAuth specific error messages
  RATE_LIMITED: 'Твърде много заявки. Моля, изчакайте преди да опитате отново',
  PASSWORD_POLICY_VIOLATION: 'Паролата не отговаря на изискванията за сигурност',
  ACCOUNT_DISABLED: 'Вашият профил е деактивиран. Свържете се с поддръжката',
  ACCOUNT_PENDING: 'Вашият профил очаква одобрение',
  INVALID_EMAIL_FORMAT: 'Моля, въведете валиден имейл адрес',
  PASSWORD_EXPIRED: 'Паролата ви е изтекла. Моля, нулирайте я',
  SESSION_EXPIRED: 'Сесията ви е изтекла. Моля, влезте отново',
  FORBIDDEN_ACTION: 'Нямате право да извършите това действие',
  SERVICE_UNAVAILABLE: 'Услугата за удостоверяване е временно недостъпна',
  MAINTENANCE_MODE: 'Системата е в режим на поддръжка. Опитайте отново по-късно',
  
  // Two-Factor Authentication messages
  TWO_FACTOR_REQUIRED: 'Изисква се двуфакторно удостоверяване',
  TWO_FACTOR_CODE_INVALID: 'Невалиден код за двуфакторно удостоверяване',
  TWO_FACTOR_CODE_EXPIRED: 'Кодът за двуфакторно удостоверяване е изтекъл',
  TWO_FACTOR_SETUP_REQUIRED: 'Моля, настройте двуфакторно удостоверяване',
  
  // Account status messages
  ACCOUNT_INCOMPLETE: 'Моля, завършете настройката на профила си',
  EMAIL_VERIFICATION_REQUIRED: 'Моля, потвърдете имейл адреса си за да продължите',
  EMAIL_VERIFICATION_SENT: 'Изпратен е имейл за потвърждение. Проверете пощата си',
  PROFILE_INCOMPLETE: 'Моля, попълнете информацията в профила си',
  
  // Network and API errors
  CONNECTION_TIMEOUT: 'Изтичане на връзката. Моля, проверете интернет връзката си',
  SERVER_ERROR: 'Грешка в сървъра. Моля, опитайте отново по-късно',
  BAD_REQUEST: 'Невалидна заявка. Моля, проверете въведените данни',
  UNAUTHORIZED: 'Неуспешно удостоверяване. Моля, опитайте отново',
  
  // Password policy messages
  PASSWORD_TOO_WEAK: 'Паролата е твърде слаба. Използвайте по-силна парола',
  PASSWORD_REUSED: 'Не можете да използвате отново предишна парола',
  PASSWORD_COMMON: 'Тази парола е твърде обичайна. Изберете по-уникална парола',
  
  // Additional PropelAuth error messages
  DOMAIN_NOT_ALLOWED: 'Имейл домейнът не е разрешен',
  INVALID_FORM_DATA: 'Невалидни данни във формата. Проверете въведената информация',
  PASSWORD_LOGIN_DISABLED: 'Входът с парола е временно деактивиран. Моля, използвайте алтернативни методи за вход',
  ORG_CREATION_REQUIRED: 'Изисква се създаване на Хотел. Пренасочване...',
};

export default locale;